<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailHuiChangList"
      data-title="收款计划"
    >
      <c_cell title="总额">
        <c_money
          :key="state.statistics?.total_amount"
          :value="state.statistics?.total_amount"
          :prefix="false"
          bold
          color="#000"
        />
      </c_cell>
      <c_cell title="已收">
        <template #default>
          <c_money
            :key="state.statistics?.total_collected_amount"
            :value="state.statistics?.total_collected_amount"
            :prefix="false"
            color="#080"
          />
        </template>
      </c_cell>
      <c_cell title="欠款">
        <template #default>
          <c_statistics
            :key="state.statistics?.total_uncollected_amount"
            :value="state.statistics?.total_uncollected_amount"
            :duration="500"
            :prefix="false"
          />
        </template>
      </c_cell>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg p-2.5">
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="名称" label2="所属甲方" />
          </template>
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <strong>{{ row.name }}</strong>
              </template>
              <template #bottom>
                <text>{{ row.customer?.name }}</text>
                <text class="text-gray-400 text-xs">{{
                  row.customer?.number
                }}</text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          label="款项说明"
          prop="intro"
          :min-width="200"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="金额"
          prop="amount"
          :width="120"
          align="center"
          :formatter="$tab_PriceFormat"
        />
        <el-table-column
          label="已收"
          prop="collected_amount"
          :width="120"
          align="center"
          :formatter="$tab_PriceFormat"
        />
        <el-table-column
          label="欠款"
          prop="uncollected_amount"
          :width="120"
          align="center"
          :formatter="$tab_MoneyFormat"
        />
        <el-table-column label="操作" fixed="right" align="center" :width="260">
          <template #default="{ row }">
            <el-button
              type="primary"
              :icon="Search"
              link
              @click="
                state.selectId = row.id;
                state.showDetail = true;
              "
            >
              查看
            </el-button>
            <el-button
              type="warning"
              :icon="Edit"
              link
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
              v-if="row.collected_amount == 0"
              >编辑
            </el-button>
            <el-button
              type="danger"
              :icon="Delete"
              link
              @click="onDelete(row)"
              v-if="row.collected_amount == 0"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="`${state.selectId ? '编辑' : '新建'}收款计划`"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
    :width="500"
  >
    <c_info
      :meeting_id="props.meeting_id"
      :id="state.selectId"
      @close="
        state.showInfo = false;
        onLoad();
      "
    />
  </el-dialog>
  <el-dialog
    v-model="state.showDetail"
    title="收款详情"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showDetail = false;
      }
    "
  >
    <c_detail
      :id="state.selectId"
      @close="
        state.showDetail = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  meeting_collected_plan_page,
  meeting_collected_plan_delete,
} from "@/http/meeting";
import { onDeleteConfirm } from "@/utils/funcs";

import c_info from "./Info.vue";
import c_detail from "./Detail.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number,
  },
  components: {
    c_info,
    c_detail,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.meeting_id = props.meeting_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;
      meeting_collected_plan_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count, statistics } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
          state.statistics = statistics;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(meeting_collected_plan_delete, row.id, onLoad, {
        filed: "收款计划",
        name: row.name,
      });
    };

    return { state, props, onLoad, onDelete };
  },
};
</script>

<style lang="scss" scoped></style>
